import * as React from 'react'

import Container from '../Container'
import Row from '../Row'
import Col from '../Col'

import * as styles from './Footer.module.scss'

const Footer = () => (
  <footer className={styles.footer}>
    <Container>
      <hr className={styles.footerRule} />
      <p>
        <small>
          Images from <a href="https://unsplash.com/" target="_blank">Unsplash</a>.{' '}
          Built with <a href="https://www.gatsbyjs.org/" target="_blank">Gatsby</a> on AWS.
        </small>
      </p>
    </Container>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.tsx